import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=5c7d08d9&"
import script from "./MultipleSelect.vue?vue&type=script&lang=ts&"
export * from "./MultipleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports